// extracted by mini-css-extract-plugin
export var wrapper = "carousel-module--wrapper--W8eUE";
export var swiperButton = "carousel-module--swiper-button--GC4n5";
export var swiperButtonPrev = "carousel-module--swiper-button-prev--OpKSm";
export var swiperButtonNext = "carousel-module--swiper-button-next--Hsx8M";